/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./App.vue.js?vue&type=template&id=477ab8da!=!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=477ab8da"
import script from "./App.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports